import { BaseEntity } from 'src/app/tools/models/baseEntity';

export class PartnerAnalysisGroup4 extends BaseEntity{

    partnerAnalysisGroup4Code : string;
    name : string;
    rank : number;
    
}

